import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useOperationalDirectory } from "@/hooks/queries/useOperationalDirectory";
import { useAuth } from "@/App";

interface ResponsibleAgentSelectProps {
  value: number | undefined; // undefined = "moi-même" (the logged-in user)
  onChange: (userId: number | undefined) => void;
  label?: string;
  helperText?: string;
}

// "Employé responsable" — lets a manager+ record a transaction on behalf of
// another employee while the real actor stays on record server-side
// (createdBy/agentId, unchanged). Defaults to "Moi-même" so the common
// self-entry case needs no extra click.
export function ResponsibleAgentSelect({
  value,
  onChange,
  label = "Employé responsable",
  helperText = "L'activité sera comptabilisée dans les statistiques de cet employé. L'audit conservera l'utilisateur qui saisit l'opération.",
}: ResponsibleAgentSelectProps) {
  const { data: directory = [] } = useOperationalDirectory();
  const { user } = useAuth();

  return (
    <div>
      <Label>{label}</Label>
      <Select
        value={value ? String(value) : "self"}
        onValueChange={(v) => onChange(v === "self" ? undefined : Number(v))}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="self">Moi-même{user ? ` (${user.fullName})` : ""}</SelectItem>
          {directory
            .filter((d) => d.id !== user?.id)
            .map((d) => (
              <SelectItem key={d.id} value={String(d.id)}>
                {d.fullName}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
      {helperText && <p className="mt-1 text-[10.5px] text-muted-foreground">{helperText}</p>}
    </div>
  );
}
